export default __webpack_public_path__ + "static/klktn-8f41a7f89905b98eb4b7d618c62b0c49.png";